// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "-29.408.0-" + "06c3976781a3b066abf4" + ".js";
};